import { render, staticRenderFns } from "./OverlayEmpty.vue?vue&type=template&id=4385eae2&scoped=true"
import script from "./OverlayEmpty.vue?vue&type=script&lang=ts"
export * from "./OverlayEmpty.vue?vue&type=script&lang=ts"
import style0 from "./OverlayEmpty.vue?vue&type=style&index=0&id=4385eae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4385eae2",
  null
  
)

export default component.exports